// extracted by mini-css-extract-plugin
module.exports = {"searchEmailWrap":"EmailNotifications_searchEmailWrap__2-j_b","searchEmail":"EmailNotifications_searchEmail__2vafI"};